<template>
  <div aria-busy="true" aria-live="polite" class="competency-detail-skeleton" role="status">
    <span class="sr-only">Yetkinlik detayı yükleniyor...</span>

    <div v-if="showMemberContext" aria-hidden="true" class="competency-detail-skeleton__member">
      <span class="skl skl--avatar"></span>
      <div class="competency-detail-skeleton__member-info">
        <span class="skl skl--label"></span>
        <span class="skl skl--name"></span>
        <span class="skl skl--meta"></span>
      </div>
      <span class="skl skl--button"></span>
    </div>

    <section aria-hidden="true" class="competency-detail-skeleton__card">
      <header class="competency-detail-skeleton__header">
        <div class="competency-detail-skeleton__identity">
          <span class="skl skl--icon"></span>
          <span class="skl skl--title"></span>
        </div>
        <div class="competency-detail-skeleton__dates">
          <div>
            <span class="skl skl--date-label"></span>
            <span class="skl skl--date-value"></span>
          </div>
          <div>
            <span class="skl skl--date-label"></span>
            <span class="skl skl--date-value"></span>
          </div>
        </div>
      </header>

      <div class="competency-detail-skeleton__section">
        <span class="skl skl--section-title"></span>
        <span class="skl skl--line"></span>
        <span class="skl skl--line skl--line-short"></span>
        <span class="skl skl--line skl--line-medium"></span>
      </div>

      <div class="competency-detail-skeleton__section competency-detail-skeleton__section--bordered">
        <span class="skl skl--section-title"></span>
        <span class="skl skl--line skl--line-medium"></span>
      </div>

      <div class="competency-detail-skeleton__comments">
        <div class="competency-detail-skeleton__comments-heading">
          <span class="skl skl--section-title"></span>
          <span class="skl skl--badge"></span>
        </div>

        <div
            v-for="n in commentCount"
            :key="`comment-skeleton-${n}`"
            class="competency-detail-skeleton__comment"
        >
          <span class="skl skl--comment-avatar"></span>
          <div class="competency-detail-skeleton__comment-body">
            <span class="skl skl--comment-name"></span>
            <span class="skl skl--line"></span>
            <span class="skl skl--line skl--line-short"></span>
          </div>
        </div>

        <div class="competency-detail-skeleton__form">
          <span class="skl skl--form-label"></span>
          <span class="skl skl--textarea"></span>
          <span class="skl skl--submit"></span>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "CompetencyDetailSkeleton",
  props: {
    showMemberContext: {
      type: Boolean,
      default: false,
    },
    commentCount: {
      type: Number,
      default: 2,
    },
  },
};
</script>

<style scoped>
.competency-detail-skeleton {
  display: grid;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  gap: 16px;
  box-sizing: border-box;
}

.competency-detail-skeleton__member {
  display: flex;
  align-items: center;
  gap: 13px;
  padding: 15px 18px;
  background: #fff;
  border: 1px solid #e8edf5;
  border-radius: 12px;
}

.competency-detail-skeleton__member-info {
  flex: 1;
  min-width: 0;
}

.competency-detail-skeleton__card {
  width: 100%;
  min-width: 0;
  overflow: hidden;
  background: #fff;
  border: 1px solid #e6eaf0;
  border-radius: 12px;
  box-shadow: 0 4px 18px rgba(37, 48, 68, 0.06);
  box-sizing: border-box;
}

.competency-detail-skeleton__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 26px 28px;
  background: linear-gradient(135deg, #f7faff 0%, #fff 70%);
  border-bottom: 1px solid #e9edf3;
}

.competency-detail-skeleton__identity {
  display: flex;
  align-items: center;
  gap: 16px;
  min-width: 0;
  flex: 1;
}

.competency-detail-skeleton__dates {
  display: flex;
  flex: 0 0 auto;
  gap: 26px;
}

.competency-detail-skeleton__section {
  padding: 24px 28px;
  border-bottom: 1px solid #edf0f4;
}

.competency-detail-skeleton__comments {
  padding: 26px 28px 30px;
}

.competency-detail-skeleton__comments-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
}

.competency-detail-skeleton__comment {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 18px;
  margin-bottom: 14px;
  border: 1px solid #e7ebf0;
  border-radius: 10px;
}

.competency-detail-skeleton__comment-body {
  flex: 1;
  min-width: 0;
}

.competency-detail-skeleton__form {
  margin-top: 18px;
}

.skl {
  display: block;
  border-radius: 6px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: competency-detail-skeleton-loading 1.5s infinite;
}

.skl--avatar {
  flex: 0 0 48px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
}

.skl--icon {
  flex: 0 0 58px;
  width: 58px;
  height: 58px;
  border-radius: 50%;
}

.skl--comment-avatar {
  flex: 0 0 44px;
  width: 44px;
  height: 44px;
  border-radius: 50%;
}

.skl--label {
  width: 110px;
  height: 10px;
  margin-bottom: 8px;
}

.skl--name {
  width: 48%;
  max-width: 180px;
  height: 15px;
}

.skl--meta {
  width: 70%;
  max-width: 260px;
  height: 11px;
  margin-top: 8px;
}

.skl--button {
  flex: 0 0 120px;
  width: 120px;
  height: 34px;
  border-radius: 8px;
}

.skl--title {
  width: 55%;
  max-width: 280px;
  height: 22px;
}

.skl--date-label {
  width: 72px;
  height: 10px;
  margin-bottom: 8px;
}

.skl--date-value {
  width: 88px;
  height: 13px;
}

.skl--section-title {
  width: 96px;
  height: 14px;
  margin-bottom: 14px;
}

.skl--line {
  width: 100%;
  height: 12px;
  margin-bottom: 10px;
}

.skl--line:last-child {
  margin-bottom: 0;
}

.skl--line-short {
  width: 62%;
}

.skl--line-medium {
  width: 82%;
}

.skl--badge {
  width: 28px;
  height: 28px;
  border-radius: 50%;
}

.skl--comment-name {
  width: 40%;
  max-width: 140px;
  height: 12px;
  margin-bottom: 12px;
}

.skl--form-label {
  width: 140px;
  height: 13px;
  margin-bottom: 10px;
}

.skl--textarea {
  width: 100%;
  height: 110px;
  margin-bottom: 12px;
  border-radius: 8px;
}

.skl--submit {
  width: 120px;
  height: 40px;
  margin-left: auto;
  border-radius: 8px;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

@keyframes competency-detail-skeleton-loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

@media (max-width: 800px) {
  .competency-detail-skeleton {
    gap: 12px;
  }

  .competency-detail-skeleton__member {
    flex-wrap: wrap;
    gap: 10px;
    padding: 12px;
  }

  .skl--avatar {
    flex-basis: 40px;
    width: 40px;
    height: 40px;
  }

  .skl--button {
    flex: 1 1 100%;
    width: 100%;
    height: 36px;
  }

  .competency-detail-skeleton__header {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    padding: 18px 16px;
  }

  .skl--icon {
    flex-basis: 46px;
    width: 46px;
    height: 46px;
  }

  .skl--title {
    width: 70%;
    height: 18px;
  }

  .competency-detail-skeleton__dates {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    width: 100%;
    gap: 12px;
  }

  .competency-detail-skeleton__section,
  .competency-detail-skeleton__comments {
    padding: 18px 16px;
  }

  .competency-detail-skeleton__comment {
    padding: 14px;
  }

  .skl--submit {
    width: 100%;
    margin-left: 0;
  }
}

@media (max-width: 480px) {
  .competency-detail-skeleton__header {
    gap: 12px;
    padding: 14px 12px;
  }

  .competency-detail-skeleton__section,
  .competency-detail-skeleton__comments {
    padding: 14px 12px;
  }

  .competency-detail-skeleton__dates {
    gap: 8px;
  }

  .competency-detail-skeleton__comment {
    gap: 8px;
    padding: 12px;
  }
}
</style>
